import { Space, SpaceProps } from 'antd';

const VSpace = (props: SpaceProps) => <Space {...props} direction="vertical" style={{ ...props.style, width: "100%" }} />
export default VSpace
